<template>
  <error-layout error="Game account for this user is not found."></error-layout>
</template>

<script>
import ErrorLayout from '../layouts/ErrorLayout.vue';

export default {
  metaInfo() {
    return {
      title: '404 – Account is not found',
    };
  },
  components: { ErrorLayout },
};
</script>
